/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const CheckDefaultIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="CheckDefaultIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.3536 4.35355L6.85371 10.8541C6.75994 10.9479 6.63275 11.0006 6.50014 11.0006C6.36752 11.0006 6.24033 10.9479 6.14656 10.8541L2.64642 7.35355L3.35357 6.64649L6.50014 9.79342L12.6464 3.64648L13.3536 4.35355Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

CheckDefaultIcon.tags = [
  'confirm',
  'mark',
  'yes',
  'check',
  'approve',
  'select',
];

CheckDefaultIcon.category = 'General Icons';

CheckDefaultIcon.iconSize = 16;
